module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "users-index"
    }
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v("Usuários")]), (!_vm.currentUser().isSeller() && !_vm.current_user.isMonitoringManager()) ? _c('div', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "id": "user-invitation",
      "disabled": _vm.isInvitationDisabled()
    },
    on: {
      "click": function($event) {
        return _vm.invitation()
      }
    }
  }, [_c('div', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v("Convidar Usuário")]) : _vm._e(), _c('div', {
    staticClass: "clear"
  }), (_vm.current_user.isAdmin()) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "company_id"
    }
  }, [_vm._v("Empresa")]), _c('v-autocomplete', {
    attrs: {
      "id": "id",
      "auto-select-one-item": false,
      "items": _vm.company_options,
      "input-attrs": _vm.attrs
    },
    on: {
      "change": _vm.searchCompanies,
      "item-selected": _vm.selectedCompany
    },
    model: {
      value: (_vm.company_name),
      callback: function($$v) {
        _vm.company_name = $$v
      },
      expression: "company_name"
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('br'), _c('span', {
    staticClass: "user-count-label"
  }, [_vm._v("Número de usuários comuns: "), _c('span', {
    staticClass: "user-count"
  }, [_vm._v(_vm._s(_vm.company.number_of_regular_users) + "/" + _vm._s(_vm.max_number_of_regular_users))])]), _c('br'), _c('span', {
    staticClass: "user-count-label"
  }, [_vm._v("Número de gestores de acompanhamento: "), _c('span', {
    staticClass: "user-count"
  }, [_vm._v(_vm._s(_vm.company.number_of_monitoring_managers) + "/" + _vm._s(_vm.max_number_of_monitoring_managers))])])]), _c('div', {
    staticClass: "clear"
  }), _c('br'), _c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadUsers),
      expression: "loadUsers"
    }],
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-body"
  }, [_c('hr'), _vm._l((_vm.users), function(user) {
    return _c('list-item', {
      key: user.id,
      attrs: {
        "user": user
      },
      on: {
        "updated": _vm.userUpdated,
        "destroy": _vm.showDestroyModal
      }
    })
  })], 2)]), _c('div', {
    attrs: {
      "align": "center"
    }
  }, [_c('loading', {
    attrs: {
      "loading": _vm.loading
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "light-gray-text light-text"
  }, [_vm._v("Sem mais resultados")])], 1), _c('destroy-modal', {
    attrs: {
      "user": _vm.destroy_user
    },
    on: {
      "destroyed": _vm.userDestroyed
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f86fca2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/index.vue
// module id = 1088
// module chunks = 1